import { render, staticRenderFns } from "./EmptySettings.vue?vue&type=template&id=39b2d8a2&scoped=true"
import script from "./EmptySettings.vue?vue&type=script&lang=js"
export * from "./EmptySettings.vue?vue&type=script&lang=js"
import style0 from "./EmptySettings.vue?vue&type=style&index=0&id=39b2d8a2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2d8a2",
  null
  
)

export default component.exports